import React, { useMemo } from 'react'

import { PREFERENCES } from '../../user/constants'

import { useIncidentsFetch } from '../../incidents/hooks'
import { useAILayersFetch } from '../../aiLayers/hooks'
import { useCrimeCategoriesFetch } from '../../crimeCategories/hooks'
import { useUserPreferencesFetch, useUserPreference } from '../../user/hooks'
import { useOverlaysFetch } from '../../overlays/hooks'
import { useBuffersFetch } from '../../buffers/hooks'

import OverlayPanel from '../../overlays/components/OverlayPanel'
import IncidentPanel from '../../incidents/components/IncidentPanel'
import IncidentLayer from '../../map/components/IncidentLayer'
import UserPanel from '../../user/components/UserPanel'
import Map from '../../map/components/Map'
import Zoom from '../../map/components/Zoom'
import MeasurementTool from '../../map/components/MeasurementTool'
import BasemapToggle from '../../map/components/BasemapToggle'
import AILayer from '../../map/components/AILayer'
import TrafficLayer from '../../map/components/TrafficLayer'
import BufferLayer from '../../map/components/BufferLayer'
import OverlayLayer from '../../map/components/OverlayLayer'
import TabPanel from '../../tabs/components/TabPanel'
import TabPanelContainer from '../../tabs/components/TabPanelContainer'
import MapDataToggle from '../../mobile/components/MapDataToggle'
import MobileSidebar from '../../mobile/components/MobileSidebar'
import MobileBaseLayout from '../../mobile/components/MobileBaseLayout'
import MobileSiteSwitcher from '../../mobile/components/MobileSiteSwitcher'

const tabs = [
  { name: 'User Options', icon: 'fa fa-user', url: '/commandCentral/userMenu' },
  {
    name: 'Incident List',
    icon: 'fa fa-list-ul',
    url: '/commandCentral/incidentList',
  },
  {
    name: 'Overlays',
    icon: 'fa fa-layer-group',
    url: '/commandCentral/toggleLayers',
  },
]

const MobileLayout = () => {
  useIncidentsFetch() // Run the incident fetch loop
  useAILayersFetch() // fetch the list of ai layers
  useCrimeCategoriesFetch() // fetch the list of crime categories
  useUserPreferencesFetch() // fetch user's preferences
  useOverlaysFetch() // fetch the available overlays
  useBuffersFetch() // fetch the default buffers when an incident is selected

  const basemap = useUserPreference(PREFERENCES.DEFAULT_BASEMAP) || 'streets-vector'

  const mapPadding = useMemo(
    () => ({
      top: 60,
      bottom: 75,
    }),
    []
  )

  return (
    <MobileBaseLayout title="iRISS" basePath="/commandCentral">
      <MobileSidebar basePath="/commandCentral">
        <TabPanelContainer>
          <TabPanel path="/commandCentral/menu">
            <MobileSiteSwitcher tabs={tabs} />
          </TabPanel>
          <TabPanel path="/commandCentral/userMenu" component={UserPanel} />
          <TabPanel
            path="/commandCentral/toggleLayers"
            component={OverlayPanel}
          />
          <TabPanel
            path="/commandCentral/incidentList"
            component={IncidentPanel}
          />
        </TabPanelContainer>
      </MobileSidebar>
      <MapDataToggle
        mapPath="/commandCentral"
        listPath="/commandCentral/incidentList"
      />
      <Map basemap={basemap} padding={mapPadding}>
        <BasemapToggle
          position="top-right"
          next={basemap === 'streets-vector' ? 'satellite' : 'streets-vector'}
        />
        <MeasurementTool position="bottom-right" />
        <Zoom position="none" />
        <IncidentLayer />
        <AILayer />
        <TrafficLayer />
        <BufferLayer />
        <OverlayLayer />
      </Map>
    </MobileBaseLayout>
  )
}

export default MobileLayout
